module.exports = __webpack_public_path__ + "img/analytics-marketing-team-2.cec30c27.svg";